import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/client-logo/10_ticket24.png")